import { render, staticRenderFns } from "./lawsjxflzs.vue?vue&type=template&id=4cd2c678&"
import script from "./lawsjxflzs.vue?vue&type=script&lang=js&"
export * from "./lawsjxflzs.vue?vue&type=script&lang=js&"
import style0 from "./lawsjxflzs.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports